module.exports = function() {
  return new Worker(__webpack_public_path__ + "c5c70da466ac2bea8353.worker.js");
};